import React, { useState } from 'react';
import {
  ModalVideoFrame,
  VideoContainer,
  VideoContent,
  VideoFrame
} from './styled';
import { Modal } from '../../../ui/Modal';
import {
  Header,
  ModalContent,
  ModalFooter,
  modalStyles
} from '../../../ui/FullScreenGallery/styled';
import useScreenSize from '../../../../hooks/useScreenSize';
import { ResidenceGalleryFooter } from '../../PhotosGallery/ResidenceGalleryFooter';
import { ResidenceGalleryHeader } from '../../PhotosGallery/ResidenceGalleryHeader';

interface PromoVideoProps {
  videoId: string;
  galleryDescription: string;
  priceInfo: string;
}

export const PromoVideo: React.FC<PromoVideoProps> = ({
  videoId,
  galleryDescription,
  priceInfo
}) => {
  const { isSmallOrLargeDesktop } = useScreenSize();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <VideoContainer
        onClick={onOpenModal}
        data-cy="residence-construction-video"
      >
        <VideoFrame
          src={`https://www.youtube.com/embed/${videoId}`}
          title={videoId}
          allowFullScreen
          frameBorder="0"
          data-stat="residence-video"
        />
      </VideoContainer>

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          modalId="promo-video-modal"
          modalStyles={modalStyles}
          cypress="promo-video-modal"
          withAnimation={false}
        >
          <ModalContent>
            <Header>
              <ResidenceGalleryHeader
                galleryDescription={galleryDescription}
                priceInfo={priceInfo}
                onClose={handleCloseModal}
                showPhoneButton={false}
              />
            </Header>
            <VideoContent>
              <ModalVideoFrame
                src={`https://www.youtube.com/embed/${videoId}`}
                title={videoId}
                allowFullScreen
                frameBorder="0"
              />
            </VideoContent>
            <ModalFooter>
              {!isSmallOrLargeDesktop && (
                <ResidenceGalleryFooter
                  galleryDescription={galleryDescription}
                  priceInfo={priceInfo}
                  showPhoneButton={false}
                />
              )}
            </ModalFooter>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};
